var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTimeHistory = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12,
  fill: "none",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M2.64 3.948a3.938 3.938 0 0 0 .547 4.808v-.88a.563.563 0 0 1 1.126 0v2.25c0 .31-.252.562-.563.562H1.5a.563.563 0 0 1 0-1.125h.903a5.062 5.062 0 1 1 5.505 1.127.563.563 0 0 1-.424-1.043 3.936 3.936 0 0 0 1.95-5.574 3.937 3.937 0 0 0-6.794-.125Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M6 3.563c.31 0 .563.251.563.562v1.642l1.335 1.335a.563.563 0 0 1-.796.796l-1.5-1.5A.563.563 0 0 1 5.437 6V4.125c0-.31.252-.563.563-.563Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgTimeHistory);
export default ForwardRef;